"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Constraint2 = _interopRequireDefault(require("../Constraint"));

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @class ./constraints/Basic/DateTime
 */
var DateTime =
/*#__PURE__*/
function (_Constraint) {
  _inherits(DateTime, _Constraint);

  /**
   * Constructor.
   *
   * @param {String} errorMessage
   */
  function DateTime() {
    var _this;

    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, DateTime);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateTime).call(this));
    Object.defineProperty(_assertThisInitialized(_this), "isValid", {
      enumerable: true,
      writable: true,
      value: function value() {
        _newArrowCheck(this, this);

        var isValid = false;
        var isEmpty = new _index.IsBlank().setValue(_this.value).isValid();
        var minLength = new _index.MinLength(16).setValue(_this.value).isValid();
        var maxLength = new _index.MaxLength(20).setValue(_this.value).isValid();

        if (!isEmpty && minLength && maxLength) {
          var bits = _this.value.split(' ');

          var date = bits[0],
              time = bits[1];
          var isValidDate = new _index.Date().setValue(date).isValid();
          var isValidTime = new _index.Time().setValue(time).isValid();

          if (isValidDate && isValidTime) {
            isValid = true;
          }
        }

        return isValid;
      }.bind(this)
    });
    _this.message = 'This is not valid datetime.';

    if (errorMessage !== '') {
      _this.message = errorMessage;
    }

    return _this;
  }
  /**
   * Validates passed value.
   *
   * @returns {Boolean}
   */


  return DateTime;
}(_Constraint2.default);

var _default = DateTime;
exports.default = _default;